import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type NotificationOverridesStateFragment = { __typename?: 'NotificationOverridesStateData', tenantId: string, scope: Types.NotificationOverrideScope, scopeId: string, sendChoices: Array<{ __typename?: 'NotificationSendChoiceEntryData', docType: Types.OrderEmailDocType, choice: Types.NotificationSendChoice }>, recipients: Array<{ __typename?: 'NotificationRecipientsEntryData', docType: Types.OrderEmailDocType, excludedEmails: Array<string>, additionalEmails: Array<string> }>, documentReports: Array<{ __typename?: 'NotificationDocumentReportEntryData', kind: Types.NotificationDocumentKind, reportId: string }>, textRecipients: Array<{ __typename?: 'NotificationTextRecipientsEntryData', docType: Types.OrderEmailDocType, excludedMobiles: Array<{ __typename?: 'NotificationExcludedMobileData', contactId: string, phoneNumber: string }> }> };

export type SetNotificationSendChoiceMutationVariables = Types.Exact<{
  input: Types.SetNotificationSendChoiceInput;
}>;


export type SetNotificationSendChoiceMutation = { __typename?: 'Mutation', setNotificationSendChoice: { __typename?: 'NotificationOverridesPayload', notificationOverrides?: { __typename?: 'NotificationOverridesStateData', tenantId: string, scope: Types.NotificationOverrideScope, scopeId: string, sendChoices: Array<{ __typename?: 'NotificationSendChoiceEntryData', docType: Types.OrderEmailDocType, choice: Types.NotificationSendChoice }>, recipients: Array<{ __typename?: 'NotificationRecipientsEntryData', docType: Types.OrderEmailDocType, excludedEmails: Array<string>, additionalEmails: Array<string> }>, documentReports: Array<{ __typename?: 'NotificationDocumentReportEntryData', kind: Types.NotificationDocumentKind, reportId: string }>, textRecipients: Array<{ __typename?: 'NotificationTextRecipientsEntryData', docType: Types.OrderEmailDocType, excludedMobiles: Array<{ __typename?: 'NotificationExcludedMobileData', contactId: string, phoneNumber: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetNotificationRecipientsMutationVariables = Types.Exact<{
  input: Types.SetNotificationRecipientsInput;
}>;


export type SetNotificationRecipientsMutation = { __typename?: 'Mutation', setNotificationRecipients: { __typename?: 'NotificationOverridesPayload', notificationOverrides?: { __typename?: 'NotificationOverridesStateData', tenantId: string, scope: Types.NotificationOverrideScope, scopeId: string, sendChoices: Array<{ __typename?: 'NotificationSendChoiceEntryData', docType: Types.OrderEmailDocType, choice: Types.NotificationSendChoice }>, recipients: Array<{ __typename?: 'NotificationRecipientsEntryData', docType: Types.OrderEmailDocType, excludedEmails: Array<string>, additionalEmails: Array<string> }>, documentReports: Array<{ __typename?: 'NotificationDocumentReportEntryData', kind: Types.NotificationDocumentKind, reportId: string }>, textRecipients: Array<{ __typename?: 'NotificationTextRecipientsEntryData', docType: Types.OrderEmailDocType, excludedMobiles: Array<{ __typename?: 'NotificationExcludedMobileData', contactId: string, phoneNumber: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetNotificationDocumentReportMutationVariables = Types.Exact<{
  input: Types.SetNotificationDocumentReportInput;
}>;


export type SetNotificationDocumentReportMutation = { __typename?: 'Mutation', setNotificationDocumentReport: { __typename?: 'NotificationOverridesPayload', notificationOverrides?: { __typename?: 'NotificationOverridesStateData', tenantId: string, scope: Types.NotificationOverrideScope, scopeId: string, sendChoices: Array<{ __typename?: 'NotificationSendChoiceEntryData', docType: Types.OrderEmailDocType, choice: Types.NotificationSendChoice }>, recipients: Array<{ __typename?: 'NotificationRecipientsEntryData', docType: Types.OrderEmailDocType, excludedEmails: Array<string>, additionalEmails: Array<string> }>, documentReports: Array<{ __typename?: 'NotificationDocumentReportEntryData', kind: Types.NotificationDocumentKind, reportId: string }>, textRecipients: Array<{ __typename?: 'NotificationTextRecipientsEntryData', docType: Types.OrderEmailDocType, excludedMobiles: Array<{ __typename?: 'NotificationExcludedMobileData', contactId: string, phoneNumber: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetNotificationTextRecipientsMutationVariables = Types.Exact<{
  input: Types.SetNotificationTextRecipientsInput;
}>;


export type SetNotificationTextRecipientsMutation = { __typename?: 'Mutation', setNotificationTextRecipients: { __typename?: 'NotificationOverridesPayload', notificationOverrides?: { __typename?: 'NotificationOverridesStateData', tenantId: string, scope: Types.NotificationOverrideScope, scopeId: string, sendChoices: Array<{ __typename?: 'NotificationSendChoiceEntryData', docType: Types.OrderEmailDocType, choice: Types.NotificationSendChoice }>, recipients: Array<{ __typename?: 'NotificationRecipientsEntryData', docType: Types.OrderEmailDocType, excludedEmails: Array<string>, additionalEmails: Array<string> }>, documentReports: Array<{ __typename?: 'NotificationDocumentReportEntryData', kind: Types.NotificationDocumentKind, reportId: string }>, textRecipients: Array<{ __typename?: 'NotificationTextRecipientsEntryData', docType: Types.OrderEmailDocType, excludedMobiles: Array<{ __typename?: 'NotificationExcludedMobileData', contactId: string, phoneNumber: string }> }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const NotificationOverridesStateFragmentDoc = new TypedDocumentString(`
    fragment NotificationOverridesState on NotificationOverridesStateData {
  tenantId
  scope
  scopeId
  sendChoices {
    docType
    choice
  }
  recipients {
    docType
    excludedEmails
    additionalEmails
  }
  documentReports {
    kind
    reportId
  }
  textRecipients {
    docType
    excludedMobiles {
      contactId
      phoneNumber
    }
  }
}
    `, {"fragmentName":"NotificationOverridesState"});
export const SetNotificationSendChoiceDocument = new TypedDocumentString(`
    mutation SetNotificationSendChoice($input: SetNotificationSendChoiceInput!) {
  setNotificationSendChoice(input: $input) {
    notificationOverrides {
      ...NotificationOverridesState
    }
    errors {
      code
      message
    }
  }
}
    fragment NotificationOverridesState on NotificationOverridesStateData {
  tenantId
  scope
  scopeId
  sendChoices {
    docType
    choice
  }
  recipients {
    docType
    excludedEmails
    additionalEmails
  }
  documentReports {
    kind
    reportId
  }
  textRecipients {
    docType
    excludedMobiles {
      contactId
      phoneNumber
    }
  }
}`);
export const SetNotificationRecipientsDocument = new TypedDocumentString(`
    mutation SetNotificationRecipients($input: SetNotificationRecipientsInput!) {
  setNotificationRecipients(input: $input) {
    notificationOverrides {
      ...NotificationOverridesState
    }
    errors {
      code
      message
    }
  }
}
    fragment NotificationOverridesState on NotificationOverridesStateData {
  tenantId
  scope
  scopeId
  sendChoices {
    docType
    choice
  }
  recipients {
    docType
    excludedEmails
    additionalEmails
  }
  documentReports {
    kind
    reportId
  }
  textRecipients {
    docType
    excludedMobiles {
      contactId
      phoneNumber
    }
  }
}`);
export const SetNotificationDocumentReportDocument = new TypedDocumentString(`
    mutation SetNotificationDocumentReport($input: SetNotificationDocumentReportInput!) {
  setNotificationDocumentReport(input: $input) {
    notificationOverrides {
      ...NotificationOverridesState
    }
    errors {
      code
      message
    }
  }
}
    fragment NotificationOverridesState on NotificationOverridesStateData {
  tenantId
  scope
  scopeId
  sendChoices {
    docType
    choice
  }
  recipients {
    docType
    excludedEmails
    additionalEmails
  }
  documentReports {
    kind
    reportId
  }
  textRecipients {
    docType
    excludedMobiles {
      contactId
      phoneNumber
    }
  }
}`);
export const SetNotificationTextRecipientsDocument = new TypedDocumentString(`
    mutation SetNotificationTextRecipients($input: SetNotificationTextRecipientsInput!) {
  setNotificationTextRecipients(input: $input) {
    notificationOverrides {
      ...NotificationOverridesState
    }
    errors {
      code
      message
    }
  }
}
    fragment NotificationOverridesState on NotificationOverridesStateData {
  tenantId
  scope
  scopeId
  sendChoices {
    docType
    choice
  }
  recipients {
    docType
    excludedEmails
    additionalEmails
  }
  documentReports {
    kind
    reportId
  }
  textRecipients {
    docType
    excludedMobiles {
      contactId
      phoneNumber
    }
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetNotificationSendChoice: build.mutation<SetNotificationSendChoiceMutation, SetNotificationSendChoiceMutationVariables>({
      query: (variables) => ({ document: SetNotificationSendChoiceDocument, variables })
    }),
    SetNotificationRecipients: build.mutation<SetNotificationRecipientsMutation, SetNotificationRecipientsMutationVariables>({
      query: (variables) => ({ document: SetNotificationRecipientsDocument, variables })
    }),
    SetNotificationDocumentReport: build.mutation<SetNotificationDocumentReportMutation, SetNotificationDocumentReportMutationVariables>({
      query: (variables) => ({ document: SetNotificationDocumentReportDocument, variables })
    }),
    SetNotificationTextRecipients: build.mutation<SetNotificationTextRecipientsMutation, SetNotificationTextRecipientsMutationVariables>({
      query: (variables) => ({ document: SetNotificationTextRecipientsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetNotificationSendChoiceMutation, useSetNotificationRecipientsMutation, useSetNotificationDocumentReportMutation, useSetNotificationTextRecipientsMutation } = injectedRtkApi;
